import React, { useState, useEffect } from 'react';
import styles from './CollaboratorsCard.module.css';
import { NavLink } from 'react-router-dom';

const CollaboratorsCard = ({ id, company, address }) => {
    const [validBanner, setValidBanner] = useState(false);
    const [validLogo, setValidLogo] = useState(false);

    const bannerUrl = `${process.env.REACT_APP_BACKEND_URL}/uploads/bannerTrader${id}.jpeg`;
    const logoUrl = `${process.env.REACT_APP_BACKEND_URL}/uploads/logoTrader${id}.jpeg`;

    useEffect(() => {
        const checkImage = (url, setter) => {
            const img = new Image();
            img.onload = () => setter(true);
            img.onerror = () => setter(false);
            img.src = url;
        };
        checkImage(bannerUrl, setValidBanner);
        checkImage(logoUrl, setValidLogo);
    }, [bannerUrl, logoUrl]);

    return (
        <NavLink className={styles.card} style={{textDecoration:'none', color:'inherit'}} to={`/merchant/${id}`}>
            <div className={styles.banner} style={{backgroundImage: `url(${validBanner ? bannerUrl : '/TraderCard/defaultBanner.jpg'})`}}/>
            <div className={styles.data}>
                <div className={styles.logo} style={{backgroundImage: `url(${validLogo ? logoUrl : '/TraderCard/defaultLogo.png'})`}}/>
                <div className={styles.header}>
                    <h1 className={styles.title}>{company}</h1>
                    <p className={styles.address}>📍 {address}</p>
                </div>
            </div>
        </NavLink>
    );
};

export default CollaboratorsCard;
